import Patterns from '../patterns.js';

export default [
  {
    name: 'content.cs',
    label: {
      cs: 'Obsah [CS]',
      en: 'Content [CS]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 192,
    required: true,
  },
  {
    name: 'content.en',
    label: {
      cs: 'Obsah [EN]',
      en: 'Content [EN]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 192,
    required: true,
  },
  {
    name: 'hashtag',
    label: {
      cs: 'Hashtag',
      en: 'Hashtag',
    },
    type: 'string',
    pattern: Patterns.ONLY_LETTERS,
    patternErrorMessage: Patterns.ONLY_LETTERS_MESSAGE,
    minLength: 2,
    maxLength: 16,
    required: true,
  },
];
